import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M4 20a7.5 7.5 0 0 1 7.5-7.5c.877 0 2.5 0 4 1.5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-1.898 5.408a6 6 0 1 0-5.67-.25A8.25 8.25 0 0 0 3.25 20a.75.75 0 0 0 1.5 0 6.75 6.75 0 0 1 6.75-6.75c.843 0 2.195.006 3.47 1.28a.75.75 0 1 0 1.06-1.06 5.9 5.9 0 0 0-1.428-1.062M17.5 15.833a1.333 1.333 0 1 1 .481 1.026l-1.501.91a1.3 1.3 0 0 1 .005.43l1.538.908a1.333 1.333 0 1 1-.509.86l-1.537-.908a1.333 1.333 0 1 1-.028-2.139l1.559-.943a1 1 0 0 1-.008-.144m1.333-.333a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667m-3.666 2.167a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667m3.333 2.5a.333.333 0 1 1 .667 0 .333.333 0 0 1-.667 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }